module.exports = __webpack_public_path__ + "static/img/Website Image_0-E-2 Picture.074c171.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/Website Image_0-E-2 Picture.jpg
// module id = Cpf3
// module chunks = 1